import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const HeaderWrapper = styled.div`
  display: flex;
  box-sizing: border-box;
  height: 72px;
  background: ${COLORS.cirrus_white};
  padding: 0px 20px 0px 20px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${COLORS.primary_dark_blue7};
  ${responsive.TABLET_PORTRAIT`
    padding: 0px 16px 0px 8px;
    height: 56px;
  `}
  ${responsive.MOBILE`
    padding: 0px 8px 0px 0px;
    height: 56px;
  `}
  .name {
    font-weight: bold;
  }
  .left, .right {
    display: flex;
    align-items: center;
  }
  .icon {
    width: 35px;
    height: 35px;
    margin-left: 10px;
    fill: ${COLORS.primary_dark_blue7};
  }
  .icon-container {
    display: flex;
    flex: 1;
  }
  .logo {
    max-width: 100%;
    height: auto;
    display: block;
  }
  .hiddenLabel {
    clip: rect(0 0 0 0);
    clip-path: inset(100%);
  }
`;
